<template>
    <div>
        <Panel
            :title="$t('Voicemail Profiles')"
            :add-button="$store.hasRight('ADD_VOICEMAIL_PROFILES') ? $t('New Profile') : ''"
            :delete-button="$store.hasRight('DELETE_VOICEMAIL_PROFILES') && selected.length > 0"
            :page="page"
            :total-rows="totalRows"
            @delete="handleDelete"
            @input="openForm(-1)"
            @change="changePage"
        >
            <table id="voicemailprofiles_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Profile Name') }}</th>
                        <th>{{ $t('Profile Description') }}</th>
                        <th v-if="$store.hasRight('DELETE_VOICEMAIL_PROFILES')" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="profile in items" @click="(evt) => handleOpen(profile.profileId, evt)">
                        <td class="primary">
                            {{ profile.name }}
                        </td>
                        <td>{{ profile.description }}</td>
                        <td v-if="$store.hasRight('DELETE_VOICEMAIL_PROFILES')">
                            <cic-checkbox
                                :value="selected.indexOf(profile.profileId) !== -1"
                                @click="handleSelected(profile.profileId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <EditVoicemailProfile
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            :service-types="serviceTypes"
            @blur="closePopup"
            @input="saveItem"
            @updateFieldValue="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import EditVoicemailProfile from './EditVoicemailProfile';
    import { showValidationMessage } from '@/utils/Notification';

    export default {
        name: 'VoicemailProfiles',
        components: {
            Panel,
            EditVoicemailProfile,
            CicCheckbox,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                serviceTypes: [],
                selected: [],
                page: 1,
                totalRows: 0,
            };
        },
        created() {
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('voicemailprofiles/delete', { profileIds: this.selected }, () => {
                    this.selected = [];
                    this.loadTable();
                });
            },

            loadTable() {
                this.closePopup();
                load('voicemailprofiles/get', { page: this.page }, (response) => {
                    this.items = response.profiles;
                    this.totalRows = response.totalRows;
                });
            },

            openForm(profileId) {
                if (this.serviceTypes.length === 0) {
                    load('voicemailprofiles/servicetypes', {}, (response) => {
                        this.serviceTypes = response.serviceTypes;
                    });
                }

                if (profileId > 0) {
                    load('voicemailprofile/get', { profileId: profileId }, (response) => {
                        this.item = response.profile;
                    });
                } else {
                    this.item = {
                        profileId: null,
                        name: '',
                        description: '',
                        disablePin: false,
                        pin: '',
                        introType: 0,
                        emailNotification: false,
                        emailAddress: '',
                        emailAttachments: false,
                        maxMessages: 25,
                        serviceType: null,
                    };
                }
            },

            saveItem() {
                if (!this.item.name || this.item.name.trim() === '') {
                    showValidationMessage('Profile Name is a required field');
                    return;
                }

                if (!this.item.disablePin) {
                    if ((!this.item.pin || this.item.pin.trim() === '') && !this.item.profileId) {
                        showValidationMessage('Invalid PIN');
                        return;
                    }

                    if (
                        this.item.pin &&
                        this.item.pin.trim() !== '' &&
                        (!this.item.confirmPin || this.item.pin !== this.item.confirmPin)
                    ) {
                        showValidationMessage('PIN_VALUES_MUST_MATCH');
                        return;
                    }
                }

                if (this.item.emailNotification && (!this.item.emailAddress || this.item.emailAddress.trim() === '')) {
                    showValidationMessage('Email Notification Address is a required field');
                    return;
                }

                let params = {
                    ...this.item,
                    disablePin: this.item.disablePin ? 1 : 0,
                    emailNotification: this.item.emailNotification ? 1 : 0,
                    emailAttachments: this.item.emailAttachments ? 1 : 0,
                };

                save('voicemailprofile/update', params, () => {
                    this.selected = [];
                    this.loadTable();
                });
            },
        },
    };
</script>
